const STORAGE_KEYS = {
  affiliateConsultant: 'affiliateConsultant',
  affiliatePartner: 'affiliatePartner',
  allowedAsset: 'allowedAsset',
  allowedRedemption: 'allowedRedemption',
  authReturnPath: 'authReturnPath',
  order: 'order',
  redemptionForm: 'redemptionForm',
  emailResendTimeout: 'emailResendTimeout'
};

export default STORAGE_KEYS;
